
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { FormValuesEdit } from "../../types";
import { useEffect } from "react";

interface FormSelectProps {
  form: UseFormReturn<FormValuesEdit>;
  name: keyof FormValuesEdit;
  label: string;
  placeholder: string;
  options: { id: string; name: string }[];
}

export function FormSelect({
  form,
  name,
  label,
  placeholder,
  options,
}: FormSelectProps) {
  // Acceder al valor actual del campo
  const value = form.watch(name);
  
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(newValue) => {
              // Convertir el valor a número si es numérico para mantener la consistencia
              const numericValue = !isNaN(Number(newValue)) ? Number(newValue) : newValue;
              field.onChange(numericValue);
            }}
            value={field.value?.toString()}
          >
            <FormControl>
              <SelectTrigger className="w-full min-w-0">
                <SelectValue placeholder={placeholder} className="truncate">
                  {options.find(option => option.id === field.value?.toString())?.name || placeholder}
                </SelectValue>
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {options.map((option) => (
                <SelectItem key={option.id} value={option.id}>
                  {option.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
